<template>
    <div>
        <v-row　justify="center" class="mt-16">
            <v-col cols="12" sm="12" md="12">
                <h2 class="text-center">お問い合わせ完了</h2>
                <p class="text-center text--primary">
                    ありがとうございました
                </p>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col
                cols="12"
                sm="6"
                md="3"
                >
                <v-btn v-if="user" block color="blue" class="white--text" href="/documents/dashboard">ダッシュボードへ</v-btn>
                <v-btn v-else block color="blue" class="white--text" href="/documents/login">ログイン画面へ</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            user: Object,
        },
    };
</script>
